module.exports = __webpack_public_path__ + "pc/img/award2021_02.077a8616.webp";